import Cropper, { Area, Point } from "react-easy-crop";

type Props = {
    image: string;
    crop: Point;
    zoom: number;
    aspect?: number;
    onCropChange: (crop: Point) => void;
    onZoomChange: (zoom: number) => void;
    onCropComplete: (_: Area, cropped: Area) => void;
};

const CropperView = ({
    image,
    crop,
    zoom,
    aspect = 4 / 5,
    onCropChange,
    onZoomChange,
    onCropComplete,
}: Props) => {
    return (
        <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
            onCropComplete={onCropComplete}
        />
    );
};

export default CropperView;
